import type { Indication } from '@/types';

export const INDICATIONS: Indication[] = [
  {
    type: 'before_patient',
    label: 'Before Touching a Patient',
    shortLabel: 'Before Patient',
    description: 'Before touching a patient',
    moment: 1,
  },
  {
    type: 'before_aseptic',
    label: 'Before Clean/Aseptic Procedure',
    shortLabel: 'Before Aseptic',
    description: 'Before a clean/aseptic procedure',
    moment: 2,
  },
  {
    type: 'after_body_fluid',
    label: 'After Body Fluid Exposure Risk',
    shortLabel: 'After Body Fluid',
    description: 'After body fluid exposure risk',
    moment: 3,
  },
  {
    type: 'after_patient',
    label: 'After Touching a Patient',
    shortLabel: 'After Patient',
    description: 'After touching a patient',
    moment: 4,
  },
  {
    type: 'after_surroundings',
    label: 'After Touching Patient Surroundings',
    shortLabel: 'After Surroundings',
    description: 'After touching patient surroundings',
    moment: 5,
  },
];
